import { formatClockHour, type HorizonSnapshot } from "./geometry";

export function HorizonFallback({
  snapshot,
}: {
  readonly snapshot: HorizonSnapshot;
}) {
  const altitude = Math.max(snapshot.altitudeDegrees, 0);
  // Face the noon Sun: south of it we look north, north of it we look south.
  const facingSouth =
    snapshot.site.latitudeDegrees >= snapshot.solarDeclinationDegrees;
  const facingAzimuth = facingSouth ? 180 : 0;
  const relativeAzimuth =
    ((snapshot.azimuthDegrees - facingAzimuth + 540) % 360) - 180;
  const span = Math.min(Math.max(relativeAzimuth / 90, -1), 1);
  const sunX = 160 + span * 118;
  const sunY = 132 - Math.sin((altitude * Math.PI) / 180) * 112;
  const sky =
    snapshot.altitudeDegrees > 12
      ? "#6fb3ff"
      : snapshot.altitudeDegrees > 0
        ? "#c47a4a"
        : "#071018";

  return (
    <div className="fallback-exhibit">
      <div className="fallback-diagram">
        <svg
          aria-label={`Sky from ${snapshot.site.name} at ${formatClockHour(snapshot.hourOfDay)}: Sun altitude ${Math.round(snapshot.altitudeDegrees)} degrees`}
          className="fallback-orbit-svg"
          role="img"
          viewBox="0 0 320 180"
        >
          <rect fill={sky} height="180" width="320" />
          <rect fill="#1b2a22" height="48" width="320" y="132" />
          <line
            stroke="rgba(220, 232, 248, 0.7)"
            strokeWidth="2"
            x1="16"
            x2="304"
            y1="132"
            y2="132"
          />
          <path
            d="M28 132a132 132 0 0 1 264 0"
            fill="none"
            stroke="rgba(245, 184, 75, 0.45)"
            strokeDasharray="5 7"
          />
          {snapshot.sunAboveHorizon ? (
            <>
              <line
                stroke="#f5b84b"
                strokeWidth="2"
                x1="160"
                x2={sunX}
                y1="132"
                y2={sunY}
              />
              <circle cx={sunX} cy={sunY} fill="#ffb347" r="10" />
              <circle cx={sunX} cy={sunY} fill="#fff3d6" r="5" />
            </>
          ) : (
            <text
              fill="#94a3bb"
              fontSize="12"
              textAnchor="middle"
              x="160"
              y="86"
            >
              Sun below the horizon
            </text>
          )}
          <text fill="#dce8f8" fontSize="11" textAnchor="middle" x="160" y="24">
            {snapshot.site.name} · {formatClockHour(snapshot.hourOfDay)}
          </text>
          <text fill="#94a3bb" fontSize="11" textAnchor="middle" x="28" y="154">
            {facingSouth ? "East" : "West"}
          </text>
          <text fill="#dce8f8" fontSize="11" textAnchor="middle" x="160" y="154">
            {facingSouth ? "South" : "North"}
          </text>
          <text fill="#94a3bb" fontSize="11" textAnchor="middle" x="292" y="154">
            {facingSouth ? "West" : "East"}
          </text>
        </svg>
      </div>
    </div>
  );
}
